import { render, staticRenderFns } from "./message-push-native.vue?vue&type=template&id=da2d6c06&"
import script from "./message-push-native.vue?vue&type=script&lang=js&"
export * from "./message-push-native.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports